




























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Menu from '@/components/common/Menu.vue';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';
import { publicIPAddressService } from '@/components/network/public-ip-address/services/PublicIPAddressService';
import { format } from 'date-fns';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';
@Component({
  components: {
    Menu,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class PrivateNetworksTable extends Vue {
  workspaceId = 0;
  regionId = 0;
  privateNetworks = [];
  isAddingNewNetworkCardActive = false;
  name = '';
  network = '';
  publicIpAddress = '';
  publicIpAddressesForSelect = {};
  validation = false;
  networkError: any = '';
  networkRegex = true;
  isLoading = false;
  virtualMachineType = 'virtual';
  dedicatedMachineType = 'dedicated';
  machineType = this.virtualMachineType;

  @Watch('$store.state.privateNetworks.private_networks', { immediate: true, deep: true })
  onNetworksChange(data: any) {
    if (data) {
      this.privateNetworks = data;
    }
  }

  clearForm() {
    this.name = '';
    this.network = '';
    this.publicIpAddress = '';
  }

  addPrivateNetwork() {
    this.isAddingNewNetworkCardActive = !this.isAddingNewNetworkCardActive;
    this.getPublicIpAddresses();
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.getNetworkList();
  }

  getPublicIpAddresses() {
    publicIPAddressService.getPublicIPAddresses(this.workspaceId, this.regionId).then((data: any) => {
      this.publicIpAddressesForSelect = data.public_ip_addresses.filter((ip: any) => ip.state === 'idle');
    });
  }

  getNetworkList() {
    storeService.getPrivateNetworks();
  }

  create() {
    this.validation = true;
    this.networkError = '';
    this.networkRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[1-2][0-9]|[0-9])$/.test(
      this.network
    );
    if (!this.networkRegex || !this.network || !this.name || !this.publicIpAddress) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    privateNetworkService
      .createPrivateNetwork(this.workspaceId, this.regionId, {
        name: this.name,
        network: this.network,
        public_ip_address_id: this.publicIpAddress,
        type: this.machineType,
      })
      .then(() => {
        this.isLoading = false;
        this.getNetworkList();
        this.isAddingNewNetworkCardActive = false;
        this.validation = false;
        this.clearForm();
      })
      .catch(err => {
        this.isLoading = false;
        if (err.status === 422) {
          this.networkError = this.$t('error.network.' + err.data.error.network[0].error);
        }
      });
  }
}
